module.exports = __webpack_public_path__ + "static/media/drooling-face-svgrepo-com.a5ea2efb.svg";